import { VipPlanType } from 'lib/_types'

import { ContextSchema, SchemaDetail, schemaPath } from './types'

const VIP_PLAN_SCHEMA: SchemaDetail = {
  vendor: 'space.yay',
  name: 'vip_plan',
  format: 'jsonschema',
  version: '1-0-0',
}

export type VipPlanContextSchemaData = {
  plan: VipPlanType
}

export const vipPlanContextSchema = (
  data: VipPlanContextSchemaData
): ContextSchema<VipPlanContextSchemaData> => {
  return {
    schema: schemaPath(VIP_PLAN_SCHEMA),
    data,
  }
}
